import { render } from "./build.vue?vue&type=template&id=56e01934&scoped=true"
import script from "./build.vue?vue&type=script&lang=js"
export * from "./build.vue?vue&type=script&lang=js"

import "./build.vue?vue&type=style&index=0&id=56e01934&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56e01934"]])

export default __exports__